<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="header">
      <div class="title">零售成交</div>
    </div>
    <div class="closeBtn" @click="close"></div>
    <div class="content">
      <div class="tabs">
        <div
          :class="['tab-item', { active: activeTab === 'platform' }]"
          @click="switchTab('platform')"
        >
          平台零售订单
        </div>
        <div
          v-for="(label, client) in channelMap"
          :key="client"
          :class="['tab-item', { active: activeTab === Number(client) }]"
          @click="switchTab(Number(client))"
        >
          {{ label }}
        </div>
      </div>
      <a-table
        v-if="activeTab === 'platform'"
        bordered
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :scroll="{ y: 1050 }"
        @change="onChange"
      >
        <template slot="skuDetail" slot-scope="text">
          <div style="text-align:left;line-height:1.4em">{{ text.join('；') }}</div>
        </template>
      </a-table>
      <a-table
        v-else
        bordered
        :columns="thirdColumns"
        :data-source="thirdList"
        :pagination="thirdPagination"
        :scroll="{ y: 1050 }"
        @change="onThirdChange"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import { userOrderPage, thirdOrderPage } from '@/api/dashboard'
import to from '@/utils/await-to'
export default {
  name: 'UserOrderDialog',
  data() {
    return {
      visible: false,
      activeTab: 'platform',
      activeThirdClient: 1,
      channelMap: {
        1: '抖店',
        2: '微信小店',
        3: '线下活动',
        4: '线下门店',
        5: '葛洲坝文旅',
        6: '文澜好物',
        // 7: '小B端',
      },
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNumber',
          key: 'orderNumber',
          align: 'center',
          width: '15%',
        },
        {
          title: '零售客户',
          dataIndex: 'customerName',
          key: 'customerName',
          align: 'center',
          width: '12%',
        },
        {
          title: '订单详情',
          dataIndex: 'skuDetail',
          key: 'skuDetail',
          align: 'center',
          scopedSlots: { customRender: 'skuDetail' },
          width: '30%',
        },
        {
          title: '订单金额（元）',
          dataIndex: 'totalSalePrice',
          key: 'totalSalePrice',
          align: 'center',
          width: '12%',
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          width: '10%',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center',
          width: '15%',
        },
      ],
      thirdColumns: [
        // {
        //   title: '渠道',
        //   dataIndex: 'channel',
        //   key: 'channel',
        //   align: 'center',
        //   width: '10%',
        //   scopedSlots: { customRender: 'channel' },
        // },
        {
          title: '第三方订单号',
          dataIndex: 'thirdPartyOrderNo',
          key: 'thirdPartyOrderNo',
          align: 'center',
          width: '18%',
        },
        {
          title: '客户名称',
          dataIndex: 'customerName',
          key: 'customerName',
          align: 'center',
          width: '10%',
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
          key: 'orderAmount',
          align: 'center',
          width: '10%',
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          key: 'supplierName',
          align: 'center',
          width: '12%',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          align: 'center',
          width: '15%',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center',
          width: '15%',
        },
      ],
      list: [],
      thirdList: [],
      pagination: {
        current: 1,
        pageSize: 12,
        total: 0,
      },
      thirdPagination: {
        current: 1,
        pageSize: 12,
        total: 0,
      },
    }
  },
  methods: {
    show() {
      this.visible = true
      this.activeTab = 'platform'
      this.activeThirdClient = 1
      this.pagination = {
        current: 1,
        pageSize: 12,
        total: 0,
      }
      this.thirdPagination = {
        current: 1,
        pageSize: 12,
        total: 0,
      }
      this.initData()
      this.initThirdData()
    },
    close() {
      this.visible = false
    },
    switchTab(tab) {
      this.activeTab = tab
      if (tab === 'platform') {
        this.initData()
      } else {
        this.activeThirdClient = tab
        this.thirdPagination.current = 1
        this.initThirdData()
      }
    },
    async initData() {
      const [res, err] = await to(
        userOrderPage({ current: this.pagination.current, size: this.pagination.pageSize }),
      )
      if (err) return
      this.list = res.data.list
      this.pagination.total = res.data.total
    },
    async initThirdData() {
      const [res, err] = await to(
        thirdOrderPage({
          current: this.thirdPagination.current,
          size: this.thirdPagination.pageSize,
          channel: this.activeThirdClient,
        }),
      )
      if (err) return
      this.thirdList = res.data.list
      this.thirdPagination.total = res.data.total
    },
    onChange({ current }) {
      this.pagination.current = current
      this.initData()
    },
    onThirdChange({ current }) {
      this.thirdPagination.current = current
      this.initThirdData()
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3136px !important;
  height: 1638px !important;
  background: url('~@/img/agriculture/product_bg.png');
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;

  .header {
    display: flex;
    align-items: center;
    padding: 30px 0 0 60px;

    .title {
      font-size: 48px;
      color: #ffffff;
      font-weight: 500;
    }
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/agriculture/close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 60px 60px 0;
    height: calc(100% - 120px);

    .tabs {
      display: flex;
      margin-bottom: 30px;
      border-bottom: 2px solid rgba(0, 170, 136, 0.3);

      .tab-item {
        padding: 20px 40px;
        font-size: 32px;
        color: #fff;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;

        &:hover {
          color: #0095fe;
        }

        &.active {
          color: #0095fe;
          font-weight: 500;

          &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 4px;
            background: #0095fe;
          }
        }
      }
    }

    ::v-deep .ant-table {
      p {
        margin-bottom: 10px;
      }

      table {
        border-left: 1px solid #0041b8;
        border-top: 1px solid #0041b8;
      }

      .ant-table-thead {
        box-sizing: border-box;
        border: 0;
        border-color: #f2f2f2;
        font-size: 36px;
        line-height: 36px;
        background: rgba(5, 88, 159, 0.8);

        > tr > th {
          background: transparent;
          color: #fff;
          border-color: #f2f2f2;
          padding-top: 30px;
          padding-bottom: 30px;
        }
      }

      .ant-table-header {
        background: transparent;
      }

      .ant-table-body {
        background: transparent;

        &::-webkit-scrollbar {
          border-radius: 15px;
          width: 12px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-track {
          border-radius: 15px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 15px;
          background: #0041b8;
        }
      }

      .ant-table-tbody {
        font-size: 36px;
        line-height: 36px;
        color: #fff;

        > tr > td {
          border-color: #f2f2f2;
          padding-top: 24px;
          padding-bottom: 24px;
          background: rgba(0, 40, 40, 0.3);
        }

        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: rgba(0, 170, 136, 0.2);
        }
      }

      .ant-table-placeholder {
        background: transparent;
      }
    }

    ::v-deep .ant-pagination {
      width: 100%;
      text-align: center;
      padding-top: 30px;

      .ant-pagination-prev,
      .ant-pagination-next {
        width: auto;
        height: 50px;
        line-height: 50px;
        border: none;
        background: transparent;

        .ant-pagination-item-link {
          color: #fff;
          font-size: 24px;
          background: transparent;
          border: none;
        }

        &.ant-pagination-disabled {
          .ant-pagination-item-link {
            color: #666;
          }
        }
      }

      > li {
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        border: 2px solid #0041b8;
        font-weight: normal;
        font-size: 24px;
        line-height: 46px;
        text-align: center;
        background-color: transparent;
        margin: 0 8px;

        a {
          color: #0041b8;
        }

        &.ant-pagination-item-active {
          background-color: #0041b8;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: translate(-50%, -50%) scale(0);
    }

    100% {
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
